import React from 'react';
import _ from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { Card, CardHeader, Box } from '@mui/material';

import { BaseOptionChart } from '../../../../../components/chart';

export const ParticipantsAgeDistributionChart = props => {
  const { data } = props;
  _.map(data, (k, v) => console.log(k, v));

  const CHART_DATA = [
    {
      type: 'column',
      name: 'Ilość osób',
      data: _.map(data, (k, v) => k)
    }
  ];

  const chartOptions = _.merge(BaseOptionChart(), {
    stroke: { width: [0, 2, 3] },
    plotOptions: { bar: { columnWidth: '40%' } },
    fill: { type: ['solid'] },
    labels: _.map(data, (k, v) => v),
    tooltip: {
      shared: true,
      intersect: false
    },
    yaxis: [
      {
        title: {
          text: 'Liczba osób'
        }
      }
    ],
    xaxis:
      {
        title: {
          text: 'Wiek'
        }
      }

  });

  return (
    <Card sx={{ mt: 5 }}>
      <CardHeader title="Dystrybucja wiekowa" titleTypographyProps={{ variant: 'h4' }} />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart series={CHART_DATA} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
};
